import { Controller } from "@hotwired/stimulus"
import { runMcaptcha } from "../lib/mcaptcha"

export default class extends Controller {
  static targets = ["form", "success", "error", "submitBtn", "tsField", "captchaContainer", "captchaCheck", "captchaLabel", "captchaToken"]

  connect() {
    // Set timestamp for time-trap
    if (this.hasTsFieldTarget) {
      this.tsFieldTarget.value = String(Math.floor(Date.now() / 1000))
    }

    // Load mCaptcha config
    fetch('/portfolio/api/config')
      .then(r => r.json())
      .then(cfg => {
        this.mcaptchaCfg = cfg
        if (this.hasCaptchaContainerTarget && cfg.mcaptcha_sitekey) {
          this.initCaptchaUI()
        }
      })
      .catch(() => {})
  }

  initCaptchaUI() {
    this.captchaContainerTarget.innerHTML =
      '<div style="display:flex;align-items:center;gap:12px;padding:12px 16px;border-radius:10px;border:1px solid rgba(255,255,255,0.1);background:var(--bg);">' +
        '<input type="checkbox" data-portfolio-contact-target="captchaCheck" data-action="change->portfolio-contact#solveCaptcha" style="width:20px;height:20px;cursor:pointer;accent-color:var(--orange);">' +
        '<label data-portfolio-contact-target="captchaLabel" style="cursor:pointer;font-size:14px;color:var(--grey-text);margin:0;">Je ne suis pas un robot</label>' +
        '<input type="hidden" name="mcaptcha__token" data-portfolio-contact-target="captchaToken">' +
      '</div>'
  }

  solveCaptcha() {
    if (!this.captchaCheckTarget.checked) return
    this.captchaCheckTarget.disabled = true
    this.captchaLabelTarget.textContent = 'Verification...'

    runMcaptcha(this.mcaptchaCfg)
      .then(token => {
        this.captchaTokenTarget.value = token
        this.captchaLabelTarget.textContent = 'Verifie ✓'
        this.captchaLabelTarget.style.color = 'var(--green)'
      })
      .catch(() => {
        this.captchaLabelTarget.textContent = 'Erreur — reessayez'
        this.captchaLabelTarget.style.color = '#e74c3c'
        this.captchaCheckTarget.checked = false
        this.captchaCheckTarget.disabled = false
      })
  }

  submit(event) {
    event.preventDefault()

    if (!this.hasCaptchaTokenTarget || !this.captchaTokenTarget.value) {
      this.errorTarget.style.display = 'block'
      return
    }

    const btn = this.submitBtnTarget
    btn.disabled = true
    btn.textContent = '...'

    const formData = new FormData(this.formTarget)

    fetch('/portfolio/api/contact', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams(formData).toString()
    })
    .then(r => {
      if (r.ok) {
        this.successTarget.style.display = 'block'
        this.errorTarget.style.display = 'none'
        this.formTarget.reset()
      } else { throw new Error('Network error') }
    })
    .catch(() => {
      this.errorTarget.style.display = 'block'
      this.successTarget.style.display = 'none'
    })
    .finally(() => {
      btn.disabled = false
      btn.textContent = document.documentElement.lang === 'en' ? 'Send' : 'Envoyer'
    })
  }
}
